import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 사용자 메일 인증 실패 - 고도화 개발
 *
 ********************************************************************/
import { useEffect } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue } from "recoil";
import { getApiLangState } from "../../../recoil/langState";
// utils
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
function NoEhpCertification() {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userId = localStorage.getItem(CONST.STR_EMAIL);
    const { data: data, run } = useAsync({
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/auth/key",
        appQuery: {
            userId: userId,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                alert("메일 전송을 완료 하였습니다.");
            }
            else {
                alert(data.errorList.map((err) => err.msg));
            }
        }
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "login__right webmailok" }, { children: [_jsx("h2", { children: _jsx("p", Object.assign({ className: "tit" }, { children: "\uC778\uC99D \uC2E4\uD328" })) }), _jsx("div", Object.assign({ className: "login__form" }, { children: _jsx("form", Object.assign({ action: "#", method: "", name: "loginform" }, { children: _jsxs("fieldset", { children: [_jsx("p", Object.assign({ className: "login__info" }, { children: "\uBA54\uC77C \uC778\uC99D\uC774 \uC2E4\uD328 \uB418\uC5C8\uC2B5\uB2C8\uB2E4." })), _jsx("button", Object.assign({ type: "button", className: "btn-login js-open", "data-pop": "join-ok", onClick: run }, { children: _jsx("span", { children: "\uC778\uC99D\uBA54\uC77C \uC7AC\uBC1C\uC1A1" }) }))] }) })) }))] })), _jsx(JoinDone, {})] }));
}
export default NoEhpCertification;
function JoinDone(props) {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userId = localStorage.getItem(CONST.STR_EMAIL);
    const { data: data, run } = useAsync({
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/auth/key",
        appQuery: {
            userId: userId,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                alert("메일 전송을 완료 하였습니다.");
            }
        }
    }, [data]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "join-ok", className: "popup-layer js-layer layer-out hidden w560 login__popup" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uD68C\uC6D0\uAC00\uC785" }), _jsx("button", Object.assign({ className: "btn btn-close js-close" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body joinok-h webmail" }, { children: _jsxs("div", Object.assign({ className: "complete-txt" }, { children: [_jsxs("p", Object.assign({ className: "joinok" }, { children: ["\uD68C\uC6D0\uAC00\uC785\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.", _jsx("br", {}), "\u2018", localStorage.getItem(CONST.STR_EMAIL), "\u2019 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uBA54\uC77C\uC774 \uC804\uC1A1 \uB418\uC5C8\uC73C\uB2C8,", _jsx("br", {}), "\uC778\uC99D \uD6C4 \uACC4\uC18D \uC9C4\uD589\uD574 \uC8FC\uC138\uC694."] })), _jsx("button", Object.assign({ id: "certification", type: "button", onClick: run }, { children: _jsx("span", { children: "\uC778\uC99D\uBA54\uC77C \uC7AC\uBC1C\uC1A1" }) })), _jsxs("div", Object.assign({ className: "joininfo" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uC778\uC99D \uBA54\uC77C\uC774 \uB3C4\uCC29\uD558\uC9C0 \uC54A\uC73C\uC168\uB098\uC694?" })), _jsx("p", Object.assign({ className: "txt" }, { children: "\uC2A4\uD338\uBA54\uC77C\uD568\uC744 \uD655\uC778\uD558\uAC70\uB098, \uC7A0\uC2DC\uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4." }))] }))] })) }))] })) }));
}
